import { createSelector } from '@reduxjs/toolkit'
import { getCalcOutputState } from '../../../../../utils/selectors'
import { resultSlice } from './slice'

export const getResultState = (state) => getCalcOutputState(state)[resultSlice.name]
export const getSelectedRow = (state) => getResultState(state).selectedRow
export const getResultQuery = (state) => getResultState(state).query

const getResultOptimized = (state) => getResultState(state).optimized
const getResultSearchKeyword = (state) => getResultState(state).searchKeyword

export const getResultTableSettings = createSelector(getResultOptimized, getResultSearchKeyword, (optimized, searchKeyword) => ({
  optimized, searchKeyword
}))